var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3dqz69osna",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sy8kgr50hb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0z",
    transform: "translate(-399 -231) translate(16 212) translate(16 16) translate(367 3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-399 -231) translate(16 212) translate(16 16) translate(367 3) translate(.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#3dqz69osna)",
    d: "M.517 5.874C.527 2.906 2.942.507 5.91.517c2.969.01 5.367 2.425 5.357 5.393v.061c-.037 1.93-1.114 3.713-2.435 5.107-.755.785-1.599 1.48-2.514 2.07-.244.211-.607.211-.852 0-1.364-.888-2.561-2.009-3.536-3.311C1.06 8.7.567 7.322.517 5.892v-.018z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.892,
    cy: 5.977,
    r: 1.723,
    fill: "url(#sy8kgr50hb)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcPin);
export default __webpack_public_path__ + "static/media/icon-ic-pin.23c30704.svg";
export { ForwardRef as ReactComponent };